<template>
  <v-autocomplete
    label="Employee"
    v-model="employee"
    :items="employees"
    v-model:search="localQueryFilters.search"
    item-value="id"
    :item-title="
      (item: IEmployee) => {
        return item instanceof Employee ? item.getFullName() : item
      }
    "
    :loading="isLoading"
    :error-messages="combinedErrorMessages"
    no-filter
    v-bind="$attrs"
  />
</template>

<script setup lang="ts">
import { computed, type PropType, reactive } from 'vue'

import { useFetchEmployees } from '@/composables/employee'
import { isArray } from 'lodash'

import type { IEmployeeFilterParam } from '@/services'
import { Employee, type IEmployee, type IEmployeeData } from '@/models/employee'

const props = defineProps({
  errorMessages: {
    type: [String, Array, null] as PropType<string | string[] | null>,
    default: () => []
  },
  queryFilters: {
    type: Object as PropType<Partial<IEmployeeFilterParam>>,
    default: () => ({})
  }
})

const employee = defineModel<null | number | (IEmployee | IEmployeeData | number)[]>({
  default: null
})
const localQueryFilters = reactive<IEmployeeFilterParam>({
  search: '',
  page: 1,
  ...props.queryFilters
})

const { employees, error: fetchError, isLoading } = useFetchEmployees(localQueryFilters)

const combinedErrorMessages = computed(() => {
  let error: string[] = []

  if (fetchError.value) {
    error.push(fetchError.value.message)
  }
  if (isArray(props.errorMessages)) {
    error.concat(props.errorMessages)
  } else {
    if (props.errorMessages) {
      error.push(props.errorMessages)
    }
  }

  return error
})
</script>
